import React from "react";

const PERKS = [
  {
    title: "🪶 800+ Fill Power Down",
    body: "The highest grade of Hungarian goose down on the market. Three times more lift than synthetic — cloud-soft, never flat.",
  },
  {
    title: "🌾 400-TC Egyptian Cotton",
    body: "Pure organic cotton woven for 7-star hotels. So smooth it feels cool to the touch — zero scratch, zero allergens.",
  },
  {
    title: "📐 Cervical Alignment",
    body: "47 pinch-tuck chambers cradle your neck in perfect neutral position. Goodbye morning stiffness and chronic headaches.",
  },
  {
    title: "🌿 100% Organic & Hypoallergenic",
    body: "RDS-certified ethical down, GOTS-certified organic cotton, OEKO-TEX® tested. No chemicals, no compromise.",
  },
  {
    title: "🛌 Cloud-Soft, Spine-Strong",
    body: "Softer than memory foam, more supportive than feather. The unique blend that doctors recommend for chronic neck pain.",
  },
  {
    title: "♾️ 5+ Year Loft Guarantee",
    body: "Most pillows die in 6 months. Ours stays plump for 5+ years — guaranteed in writing.",
  },
];

export default function SolutionSection() {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="aurora-wrap py-20 md:py-28">
      <div className="container-x">
        <div className="text-center">
          <span className="section-pill">⚡ The solution</span>
        </div>

        <div className="mt-10 grid md:grid-cols-2 gap-10 md:gap-16 items-center max-w-5xl mx-auto">
          <div className="relative">
            <div className="aspect-square bg-white rounded-[36px] overflow-hidden border border-black/5 shadow-xl">
              <img
                src="/assets/ugc_woman_1.png"
                alt="Real customer cuddling Dubai Pillow"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="sticker sticker-lime absolute -top-4 -right-4 md:-right-8 text-[15px] md:text-[17px]">
              $147
              <br />
              <span className="font-medium text-[11px]">one-time · 5+ yrs</span>
            </div>
            <div className="sticker sticker-lavender absolute -bottom-4 -left-4 text-[12px] md:text-[13px]">
              Hand-stitched
              <br />
              in Dubai 🇦🇪
            </div>
          </div>

          <div>
            <h2 className="text-[32px] sm:text-[40px] md:text-[48px] leading-[1.05] font-black tracking-[-0.02em] text-[#0e0e10]">
              The pillow that ended
              <br />
              bad sleep forever.
            </h2>
            <p className="mt-4 text-[#5a5a60] text-[15px] md:text-[16px] leading-relaxed">
              Used in 7-star suites at Burj Al Arab, Emirates Palace and Atlantis.
              <strong className="text-[#0e0e10]"> Hand-made in 14 hours</strong> by Dubai master
              artisans using the world's finest organic materials.
            </p>

            <div className="mt-7 space-y-4">
              {PERKS.map((p) => (
                <div key={p.title} className="flex gap-3">
                  <span className="font-bold text-[14px] md:text-[15px] text-[#0e0e10] min-w-[14ch]">
                    {p.title}
                  </span>
                  <span className="text-[#5a5a60] text-[13px] md:text-[14px] leading-relaxed">
                    {p.body}
                  </span>
                </div>
              ))}
            </div>

            <button
              onClick={() => scrollTo("shop")}
              className="pill-btn mt-9 px-7 py-3.5"
            >
              Claim mine for $147 →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
